module.exports = __webpack_public_path__ + "img/plugin-how-it-works-info_2.ad8c5f78.svg";